import { createEvent, createStore } from 'effector';
import { alwaysNew } from '../lib/alwaysNew';

export type Mode = 'payout' | 'payin';

export const setMode = createEvent<Mode>();

export const $mode = createStore<Mode>('payout').on(setMode, alwaysNew);
